import { QueryClient } from "@tanstack/react-query";
import { shouldRetryApiFailure } from "@/data/api";

export function createAppQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: shouldRetryApiFailure,
        staleTime: 10_000,
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: false,
      },
    },
  });
}
